import { render, staticRenderFns } from "./ScatterplotSection.vue?vue&type=template&id=51210352&scoped=true"
import script from "./ScatterplotSection.vue?vue&type=script&lang=js"
export * from "./ScatterplotSection.vue?vue&type=script&lang=js"
import style0 from "./ScatterplotSection.vue?vue&type=style&index=0&id=51210352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51210352",
  null
  
)

export default component.exports